import { TPriceData, TReceiptProps } from './types'

export const Receipt = ({ receiptData, receiptTitle }: TReceiptProps) => {
  return (
    <div className="receipt">
      <div className="summary-container">
        {receiptTitle && <div className="title">{receiptTitle}</div>}

        {receiptData &&
          receiptData.priceInfo.map((lineInfo: TPriceData, i: number) => {
            return (
              <div key={i} className={'price-container ' + (lineInfo.extraClassName || '')}>
                <span className="text">{lineInfo.textPlan}</span>
                <div
                  className={
                    'price-wrapper ' +
                    (lineInfo.priceExtraClassName ? lineInfo.priceExtraClassName : '')
                  }
                >
                  <span>{lineInfo.textPrice}</span>
                  {lineInfo.weekTextPrice && (
                    <div className="period-price-wrapper">{lineInfo.weekTextPrice}</div>
                  )}
                </div>
              </div>
            )
          })}
      </div>
      <hr />
      <div className="total-container">
        <div className="description-wrapper">
          <span>{receiptData.totalPrice.textPlan}</span>
          {receiptData.totalPrice.periodTextPlan && (
            <div className="period-description-wrapper">
              {receiptData.totalPrice.periodTextPlan}
            </div>
          )}
        </div>
        <div className="price-wrapper">
          <span>{receiptData.totalPrice.textPrice}</span>
          {receiptData.totalPrice.weekTextPrice && (
            <div
              className="period-price-wrapper"
              dangerouslySetInnerHTML={{ __html: receiptData.totalPrice.weekTextPrice }}
            ></div>
          )}
        </div>
      </div>
    </div>
  )
}
